module.exports = __webpack_public_path__ + "img/erp05.3c601737.jpg";